import React, { useEffect, useState } from 'react'

const DarkMode = () => {

    
    const [dark, setDark] = useState(true);
    const [icon, setIcon] = useState(<i className="fa-solid fa-lightbulb"></i>);
    
    const Changer = (e) => {
        e.preventDefault();
        setDark(!dark)
        const rootElement = document.documentElement
        if (dark) {
            setIcon(<i className="fa-solid fa-lightbulb"></i>)
            rootElement.style.setProperty('--black-color', 'white')
            rootElement.style.setProperty('--white-color', 'black')
            rootElement.style.setProperty('--blue-color', '#00ABE4')
            rootElement.style.setProperty('--navy-color', '#E9F1FA')
            rootElement.style.setProperty('--gray-color', '#3e3e3e')
        }
        else {
            setIcon(<i className="fa-solid fa-lightbulb"></i>)
            rootElement.style.setProperty('--black-color', 'black')
            rootElement.style.setProperty('--white-color', 'white')
            rootElement.style.setProperty('--blue-color', '#5221e6')
            rootElement.style.setProperty('--navy-color', '#181823')
            rootElement.style.setProperty('--gray-color', 'gray')
        }
            
            
    }
        
    



    return (
        <>
            <div className='colorChanger' onClick={Changer} >
                {icon}
            </div>
        </>
    )
};

export default DarkMode